import { Injectable } from '@angular/core';
import { LinksModel } from '../models/links.model';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LinksService {

  private selectedLink: Subject<string> = new Subject();
  selectedLink$ = this.selectedLink.asObservable();

  constructor(private http: HttpClient) { }

  getData(): Observable<LinksModel> {
    return this.http.get<LinksModel>('../../../assets/links-cards.json');
  }

  getDataBenefits(): Observable<LinksModel> {
    return this.http.get<LinksModel>('../../../assets/data-benefits.json');
  }
}
